import styled from 'styled-components';
import { Icon, Input } from 'antd';

export const IconStyled = styled(Icon)`
  padding: 5px;
  border-radius: 100%;
  :hover {
    background: ${(props) => props.theme.colors.brand.secondary};
    color: ${(props) => props.theme.colors.brand.primary};
  }
`;

export const InputStyled = styled(Input)`
  border-radius: 4px 4px 0 0 !important;
  margin-top: -5px !important;
  border: none !important;
  border-bottom: 1px solid ${(props) => props.theme.colors.background.tertiary} !important;
`;

export const ActionItem = styled.div`
  background-color: ${(props) => props.theme.colors.background.primary};
  padding: 8px 12px;
  width: 100%;
  cursor: pointer;
  transition: 0.5s;
  :hover {
    background-color: ${(props) => props.theme.colors.brand.secondaryAlt};
    color: ${(props) => props.theme.colors.brand.primary};
  }
`;
